import './index.css'
import { Pencil, List, Trash2 } from 'lucide-react'
import { fmtAmt } from '../../lib/format'
import type { Goal } from '../../types'

interface GoalCardProps {
  goal: Goal
  animating: boolean
  onEdit: () => void
  onViewDetail: () => void
  onDelete: () => void
}

export default function GoalCard({ goal, animating, onEdit, onViewDetail, onDelete }: GoalCardProps) {
  const isComplete = goal.percentage >= 100

  return (
    <div className={'bc-goal-card' + (isComplete ? ' is-complete' : '')}>
      <div className="bc-goal-card__header">
        <span className="bc-goal-card__title">
          {goal.emoji && <span className="bc-goal-card__emoji">{goal.emoji}</span>}
          {isComplete && <span className="bc-goal-card__trophy">🏆</span>}
          {goal.name}
        </span>
        <div className="bc-goal-card__actions">
          <button className="bc-icon-btn" onClick={onEdit} aria-label="Editar meta">
            <Pencil size={14} />
          </button>
          <button className="bc-icon-btn" onClick={onViewDetail} aria-label="Ver contribuições">
            <List size={14} />
          </button>
          <button className="bc-icon-btn bc-icon-btn--danger" onClick={onDelete} aria-label="Excluir meta">
            <Trash2 size={14} />
          </button>
        </div>
      </div>

      <div className="bc-goal-card__bar-wrap">
        <div
          className="bc-goal-card__bar"
          style={{ width: `${goal.percentage}%` }}
        />
        {animating && <span className="bc-goal-card__flame">🔥</span>}
      </div>

      <div className="bc-goal-card__amounts">
        <span className="bc-goal-card__saved">{fmtAmt(goal.saved_amount)}</span>
        <span className="bc-goal-card__pct">{Math.round(goal.percentage)}%</span>
        <span className="bc-goal-card__target">de {fmtAmt(goal.target_amount)}</span>
      </div>

      {!isComplete && (
        <div className="bc-goal-card__remaining">
          Faltam {fmtAmt(goal.target_amount - goal.saved_amount)}
        </div>
      )}

      {goal.deadline && (
        <div className="bc-goal-card__deadline">
          Prazo: {new Date(goal.deadline + 'T00:00:00').toLocaleDateString('pt-BR')}
        </div>
      )}
    </div>
  )
}
